import React, { useState } from "react";
import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

export const DevelopmentsSection = ({
  developments,
  deletedDevelopments = [],
  navigate,
  handleDeleteDevelopment,
  handleRestoreDevelopment,
}) => {
  const [activeTab, setActiveTab] = useState("active");
  const visibleDevelopments =
    activeTab === "deleted" ? deletedDevelopments : developments;

  return (
  <AccordionItem
    value="developments"
    className="bg-background border border-border rounded-lg"
  >
    <AccordionTrigger className="px-4 sm:px-6 py-4 hover:no-underline">
      <div className="flex items-center gap-3">
        <Building2 className="w-5 h-5 text-primary" />
        <span className="font-bold text-base">
          Mis desarrollos ({developments.length})
        </span>
      </div>
    </AccordionTrigger>
    <AccordionContent>
      <div className="px-4 sm:px-6 pb-4 max-h-[500px] overflow-y-auto">
        <div className="flex gap-2 mb-4">
          <Button
            variant={activeTab === "active" ? "default" : "outline"}
            size="sm"
            onClick={() => setActiveTab("active")}
          >
            Activos ({developments.length})
          </Button>
          <Button
            variant={activeTab === "deleted" ? "default" : "outline"}
            size="sm"
            onClick={() => setActiveTab("deleted")}
          >
            Eliminados ({deletedDevelopments.length})
          </Button>
        </div>
        {visibleDevelopments.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-sm text-muted-foreground mb-3">
              {activeTab === "active"
                ? "No tienes desarrollos"
                : "No hay desarrollos eliminados"}
            </p>
            {activeTab === "active" && (
              <Button onClick={() => navigate("/add-development")}>
              Crear desarrollo
              </Button>
            )}
          </div>
        ) : (
          <div className="space-y-3">
            {visibleDevelopments.map((dev) => (
              <div
                key={dev.id}
                className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3 bg-muted/30 rounded-lg border border-border"
              >
                <div className="min-w-0">
                  <h4 className="font-medium text-sm truncate">{dev.name}</h4>
                  <p className="text-xs text-muted-foreground truncate">
                    {dev.address}
                  </p>
                </div>
                <div className="flex gap-2 shrink-0">
                  {activeTab === "deleted" ? (
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => handleRestoreDevelopment(dev.id)}
                    >
                      Restaurar
                    </Button>
                  ) : (
                    <>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => navigate(`/development/${dev.id}`)}
                      >
                        Ver
                      </Button>
                      <Button
                        size="sm"
                        variant="ghost"
                        className="text-destructive"
                        onClick={() => handleDeleteDevelopment(dev.id)}
                      >
                        Eliminar
                      </Button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AccordionContent>
  </AccordionItem>
  );
};
